import React, { useState, useEffect, useRef } from "react";
import Header from "../Components/header";
import {
  FaFlag,
  FaDollarSign,
  FaQuestionCircle,
  FaGlobe,
} from "react-icons/fa";
import * as Icons from "react-icons/fa";
import ContactForm from "../Components/ContactForm";
import { Link } from "react-scroll";
import { Helmet } from "react-helmet";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  useMutation,
  gql,
} from "@apollo/client";

import { IconComponent } from "./gestioneFaqs";

const API_KEY =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE3MTYxOTQ4MDEsImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vdjIvY2x3ZXEybTZhMDAwMDAxdzY3YXF6ZWg3eC9tYXN0ZXIiLCJtYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC1ldS1jZW50cmFsLTEtc2hhcmVkLWV1YzEtMDIuaHlncmFwaC5jb20vIiwic3ViIjoiZWYwZWJjYjEtM2IwNi00NjQ2LWFiNTItMWQwMmVlMzJmNzZmIiwianRpIjoiY2tsdXpicmxwNW9sOTAxeHY3MzI1OHRqZCJ9.j6_FyV0D25iUBrQB5EgA_e0IM-ABoTBW8E2lst5jNpC7jpkoefd98lxsIArNC4aM6E5_9MDUDF3aBZpE2vhQv8L0MXwwehcg4cyRJgZ8Ve9tTzLH5ZmZnMdN9L2EsuNxoZ9KHb50VT3-6sBHphWuXun-ufIQovt3p_WG_Fbs6X9exukEHW46y2B0YGM6D-h49g3PWg4YIcPcKoU2AOzk4LHFewzKzqvkaekAj0SZXxTIfqhpfvjafqhDKVUjTqcpo9TrGXuR7Mj8t0skdQg-p9LEHQ6StY3OjRS7iZt9EuQg21iG1A6--_m7PniC70kx494Y_CjsQvaEb3noHgav0XT5qRDVX_sru1zPLG12e-xcMPIceIej40E9oyN4HXETQn9I5zuDj7o6Fnqa8anIaf21C52qVEfD7XTOjC9ug9RwEb5Ix2r404SMNL8V5pKn81WsDE3tziYvfqm3nEf9NYSWASsVsidr_SGUFt6oGJIFF_D25jQtpnwjLpWytN7KrsG8T3t6SHa1rtGh2wf9WEaetA6qARUBJawgZD6TPNUTj7vflkzwNYFFM4dHNpaJj-tBUcTOcsutd_FLSLu5zLkbkFlDdyTUasSZGM_pZqeREHdpvKL8OZbIVSjt_NzxQp2aF3mHyQafE5PuZtjnlZBLkzmTUMa8Rf8FKtIKdIU"; // Sostituisci con la tua API key

const client = new ApolloClient({
  uri: "https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/clweq2m6a000001w67aqzeh7x/master",
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${API_KEY}`,
  },
});

const FAQs = gql`
  query MyQuery {
    faqs {
      id
      titoloFaq
      descrizione
      categoriaFaq {
        id
        titoloCategoria
      }
    }
  }
`;

const CATEGORIE = gql`
  query MyQuery {
    categorieFaq {
      id
      titoloCategoria
      icona
    }
  }
`;

const ContactUsTest = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const contactFormRef = useRef(null);
  const [faqs, setFAQs] = useState([]);
  const [categories, setCategories] = useState([]);

  const { data, loading, error } = useQuery(FAQs);
  const { data: categoriesData, loading: categoriesLoading } =
    useQuery(CATEGORIE);

  useEffect(() => {
    if (data?.faqs) {
      console.log(data.faqs.map((faq) => ({ ...faq, open: false })));
      setFAQs(data.faqs.map((faq) => ({ ...faq, open: false })));
    }
  }, [data]);

  useEffect(() => {
    if (categoriesData?.categorieFaq) {
      console.log(categoriesData.categorieFaq);
      setCategories(categoriesData.categorieFaq);
    }
  }, [categoriesData]);

  const faqData = [
    {
      question: "Quali sono le opzioni di abbonamento disponibili?",
      answer:
        "Offriamo abbonamenti annuali che comprendono 6 numeri della nostra rivista bimestrale. Puoi scegliere tra un acquisto una tantum o un rinnovo automatico al termine dell'abbonamento.",
      category: "Abbonamento e Arretrati",
      open: false,
      padding: false,
    },
    {
      question: "Come posso creare un account sul nostro sito?",
      answer:
        'Per creare un account, visita la nostra homepage e clicca su "Registrati". Compila il modulo con i tuoi dati personali e segui le istruzioni per completare la registrazione.',
      category: "Gestione dell'account",
      open: false,
    },
    {
      question: "Come posso gestire il mio abbonamento?",
      answer:
        'Dopo aver effettuato il login nel tuo account, vai alla sezione "Il mio abbonamento". Qui potrai visualizzare le informazioni sul tuo abbonamento, rinnovare o cancellare il rinnovo automatico.',
      category: "Abbonamento e Arretrati",
      open: false,
    },
    {
      question: "Quando riceverò il mio primo numero della rivista?",
      answer:
        "Il primo numero della rivista verrà spedito entro 4-6 settimane dall'acquisto dell'abbonamento. Ti informeremo via email non appena il tuo ordine sarà spedito.",
      category: "Abbonamento e Arretrati",
      open: false,
    },
    {
      question: "Quali sono i costi di spedizione?",
      answer:
        "Sì, puoi modificare l'indirizzo di spedizione accedendo al tuo account nella sezione 'Informazioni di spedizione'. Assicurati di farlo prima che l'ordine venga elaborato.",
      category: "Abbonamento e Arretrati",
      open: false,
    },
    {
      question: "Riceverò una conferma del mio abbonamento?",
      answer:
        "Il primo numero della rivista verrà spedito entro 4-6 settimane dall'acquisto dell'abbonamento. Ti informeremo via email non appena il tuo ordine sarà spedito.",
      category: "Abbonamento e Arretrati",
      open: false,
    },
    {
      question: "Come posso contattare il supporto clienti?",
      answer:
        "Puoi contattare il nostro supporto clienti inviando un'email a supporto@esempio.com oppure utilizzando il modulo di contatto disponibile sul nostro sito web.",
      category: "Gestione dell'account",
      open: false,
    },
    {
      question: "Cosa devo fare se non ricevo il mio numero?",
      answer:
        "Se non ricevi il tuo numero entro il termine previsto, ti preghiamo di contattare il nostro supporto clienti con il tuo numero di abbonamento e i dettagli del tuo ordine. Saremo lieti di aiutarti a risolvere il problema.",
      category: "Abbonamento e Arretrati",
      open: false,
    },
    // Aggiungi altre domande frequenti qui
  ];

  const [filteredFaq, setFilteredFaq] = useState(faqData);

  const [faq, setFaq] = useState(faqData);

  const toggleFAQ = (originalIndex) => {
    console.log(originalIndex);
    setFAQs(
      faqs.map((item, i) => {
        if (i === originalIndex) {
          return { ...item, open: !item.open };
        }
        return item;
      })
    );
  };

  useEffect(() => {
    console.log(selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    setFilteredFaq(
      faqs
        .map((item, originalIndex) => ({
          ...item,
          originalIndex,
        })) // Aggiungi un riferimento all'indice originale
        .filter((item) =>
          selectedCategory === "All"
            ? true
            : item.categoriaFaq.titoloCategoria === selectedCategory
        )
    );
  }, [selectedCategory, faqs]);

  useEffect(() => {
    // Chiudi tutte le FAQ ogni volta che cambia la categoria
    setFaq(faqs.map((item) => ({ ...item, open: false })));

    // Filtra in base alla categoria selezionata
    setFilteredFaq(
      faqs
        .map((item, originalIndex) => ({
          ...item,
          originalIndex, // Aggiungi un riferimento all'indice originale
        }))
        .filter((item) =>
          selectedCategory === "All"
            ? true
            : item.categoriaFaq.titoloCategoria === selectedCategory
        )
    );

    console.log(
      faqs.map((item, originalIndex) => ({
        ...item,
        originalIndex, // Aggiungi un riferimento all'indice originale
      }))
    );
  }, [selectedCategory]);

  const handleClick = () => {
    const elementPosition = contactFormRef.current?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY + 700; // Modifica qui il valore di -100 per regolare l'offset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="min-h-screen ">
      <Helmet>
        <title>Modellistica International- Supporto</title>
        <meta
          name="description"
          content="Scopri il mondo dell'aeromodellismo e modellismo con Modellistica International, la rivista dedicata agli appassionati."
        />
        <meta
          name="keywords"
          content="modellistica, aeromodelli, modellistica international, modellismo, abbonamenti modellismo, rivista modellistica abbonamento, chi siamo"
        />
      </Helmet>
      <Header />
      <div className="p-8 text-center bg-blue-100">
        <h1 className="text-4xl font-bold text-gray-800">
          Ciao, come possiamo aiutarti?
        </h1>

        {/* Categories */}
        <div className="flex justify-center space-x-6 my-8">
          <CategoryButton
            name="All"
            key="All"
            selected={selectedCategory}
            icon={<FaGlobe />}
            onClick={() => setSelectedCategory("All")}
          />

          {categories.map((categoria) => {
            //const IconComponent = Icons[categoria.icona] || null;
            return (
              <CategoryButton
                name={categoria.titoloCategoria}
                key={categoria.titoloCategoria}
                selected={selectedCategory}
                icon={
                  IconComponent ? (
                    <IconComponent iconName={categoria.icona} />
                  ) : null
                }
                onClick={() => setSelectedCategory(categoria.titoloCategoria)}
              />
            );
          })}
        </div>
      </div>

      {/* FAQ Section */}
      <div
        className="max-w-4xl mx-auto p-6 mt-10 bg-white "
        ref={contactFormRef}
      >
        <h2 className="text-3xl font-bold mb-6">Frequently Asked Questions</h2>
        <div className="grid grid-cols-1 gap-x-10">
          {filteredFaq.map((item, index) => (
            <div
              key={index}
              className={`wrapper text-left mb-4 ${
                item.open
                  ? "border-2 border-blue-500 grid-rows-[1fr] "
                  : "border border-gray-300 grid-rows-[0fr]"
              } p-4 rounded-md ease-in-out overflow-hidden grid transition-all`}
            >
              <div
                className="flex items-center cursor-pointer"
                onClick={async () => {
                  await toggleFAQ(item.originalIndex);
                }}
              >
                {/* Cerchio a sinistra della domanda */}
                <span
                  className={`w-4 h-4 border ${
                    item.open ? "border-blue-500" : ""
                  }  rounded-full mr-4`}
                ></span>
                <h3 className="text-xl font-semibold text-gray-700 mr-auto">
                  {item.titoloFaq}
                </h3>
                <span className="text-blue-500 ">{item.open ? "-" : "+"}</span>
              </div>

              <div
                className={`wrapper border-0 ${
                  item.open ? "grid-rows-[1fr]" : " grid-rows-[0fr]"
                } px-8 rounded-md ease-linear h-fit duration-200 overflow-hidden grid transition-[grid-template-rows]`}
              >
                <div className="overflow-hidden">
                  <p>{item.descrizione}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}

      <ContactForm />
      {/* Floating Contact Button */}
      <Link to="contactForm" smooth duration={500} offset={-80}>
        <button
          className="fixed bottom-14 right-4 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition duration-300"
          //onClick={handleClick}
        >
          Contattaci
        </button>
      </Link>
    </div>
  );
};

// Reusable Category Button Component
const CategoryButton = ({ name, selected, onClick, icon }) => (
  <button
    className={`flex flex-col items-center justify-center w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-36 lg:h-36 rounded-lg shadow-md ${
      selected === name
        ? "bg-blue-600 text-white"
        : "bg-white text-gray-700 hover:bg-gray-200"
    } transition-all duration-300 ease-in-out transform hover:scale-105`}
    onClick={onClick}
  >
    {/* Icona grande */}
    {icon && (
      <div className="text-2xl sm:text-3xl lg:text-4xl mb-2">{icon}</div>
    )}
    {/* Nome della categoria */}
    <span className="font-semibold text-sm sm:text-md md:text-lg">
      {name}
    </span>{" "}
  </button>
);

const App = () => (
  <ApolloProvider client={client}>
    <ContactUsTest />
  </ApolloProvider>
);

export default App;
